(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sestra-anniversary-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sa-anniversary-strip')) {
    customElements.define('sa-anniversary-strip', class extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        this.panel = this.querySelector('.sa-strip__panel--fixed');
        if (!this.panel) return;
        this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
        this.visible = false;
        this.frame = 0;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.schedule = () => {
          if (!this.active || !this.visible || this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            if (!this.active || !this.visible || !this.isConnected) return;
            const rect = this.panel.getBoundingClientRect();
            const offset = -rect.top - this.panel.clientTop;
            this.panel.style.setProperty('--sa-fixed-y', `${offset.toFixed(2)}px`);
          });
        };
        this.updateMode = () => {
          this.active = !this.reduced.matches;
          this.panel.classList.toggle('sa-strip__panel--viewport-fixed', this.active);
          if (!this.active) this.panel.style.removeProperty('--sa-fixed-y');
          this.schedule();
        };
        this.reduced.addEventListener('change', this.updateMode, options);
        window.addEventListener('scroll', this.schedule, { ...options, passive: true });
        window.addEventListener('resize', this.schedule, { ...options, passive: true });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            this.schedule();
          }, { rootMargin: '80px' });
          this.observer.observe(this.panel);
        } else { this.visible = true; }
        this.updateMode();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        cancelAnimationFrame(this.frame);
        this.events?.abort();
        this.observer?.disconnect();
        this.panel?.classList.remove('sa-strip__panel--viewport-fixed');
        this.panel?.style.removeProperty('--sa-fixed-y');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
